
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.317 19.267l7.243-7.342L7.324 4.74a1 1 0 111.409-1.42l7.943 7.887a1 1 0 01.008 1.412L8.74 20.67a1 1 0 01-1.423-1.404z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    